var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"relative"},[_c('div',{staticClass:"hero-head headroom header",class:{'headroom--unpinned': _vm.scrolled , 'tiny-scroll' : _vm.scrolledTiny , 'header-scrolled' : _vm.largeScroll},on:{"scroll":_vm.handleScroll}},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c698512","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/front/components/GeneralComponents/StickyHeader.vue
// module id = Tfez
// module chunks = 1